<!--
 * @Author: WeiZisen
 * @Date: 2020-11-09 10:48:53
 * @LastEditors: WeiZisen
 * @LastEditTime: 2020-12-23 13:51:43
 * @Description: 请输入一段描述
 * @FilePath: \bim-vue-template\src\components\ProjectTree\index.vue
-->
<template>
  <div>
    <div class="head-container">
      <el-input v-model="filterText" clearable size="small" placeholder="输入名称搜索" prefix-icon="el-icon-search" class="filter-item" />
    </div>
    <div style="overflow: auto; overflow-x: hidden" :style="{ height: treeheight - 50 + 'px' }">
      <el-tree
        ref="tree"
        :data="treeData"
        node-key="id"
        :props="defaultProps"
        accordion
        highlight-current
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      />
    </div>
  </div>
</template>

<script>
  import variables from '@/config/variables.scss'
  export default {
    name: 'ProjectTree',
    props: {
      treedata: {
        type: Array,
        default: () => [],
      },
      treeheight: {
        type: Number,
        default: 800,
      },
    },
    data() {
      return {
        variables,
        filterText: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label',
        },
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      treedata: {
        handler(newval, oldval) {
          this.treeData = newval
        },
        immediate: true,
      },
    },

    methods: {
      handleNodeClick(data) {
        if (!data.children) {
          let res = this.$route.path.split('/')
          let modulpath = res[res.length - 1]
          this.$emit('update:selectitem', data, modulpath)
        }
      },
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
    },
  }
</script>

<style lang="scss" scoped>
  .head-container {
    padding-bottom: 10px;
    .filter-item {
      display: inline-block;
      vertical-align: middle;
      margin: 0 3px 10px 0;
      input {
        height: 30.5px;
        line-height: 30.5px;
      }
    }
  }
</style>
